"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TextHolder = _styledComponents["default"].div.withConfig({
  displayName: "TextFormatter__TextHolder",
  componentId: "di14xi-0"
})(["width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:0.875rem;"]);

var TextFormatter = function TextFormatter(_ref) {
  var value = _ref.value,
      className = _ref.className;
  return _react["default"].createElement(TextHolder, {
    title: value,
    className: className
  }, value);
};

TextFormatter.propTypes = {
  value: _propTypes["default"].any.isRequired,
  className: _propTypes["default"].string
};
TextFormatter.defaultProps = {
  className: ""
};
var _default = TextFormatter;
exports["default"] = _default;